import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { UPLOAD_API } from "./config";
import toast from "react-hot-toast";
import axios from "axios";
import moment from "moment-timezone";
import Decimal from "decimal.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

function requestHeader(access_token, csrf_token) {
  return {
    headers: {
      Authorization: `Bearer ${access_token}`,
      Accept: `application/json`,
      "x-xsrf-token": csrf_token,
      "Access-Control-Allow-Credentials": true,
    },
    withCredentials: true,
  };
}

function queryHandler(filter, queryObject, pagination) {
  let query = `page_number=${pagination.page_number}&per_page=${pagination.per_page}`;
  if (
    filter.order_by &&
    filter.order_type &&
    queryObject.order.includes(filter.order_by)
  ) {
    query =
      query + `&order_by=${filter.order_by}&order_type=${filter.order_type}`;
  }

  for (let i of queryObject.filter) {
    switch (true) {
      case i.type === "string" && filter[i.name] !== "":
        query = query + `&${i.name}=${filter[i.name]}`;
        break;
      case i.type === "boolean" && filter[i.name] !== "":
        query = query + `&${i.name}=${filter[i.name]}`;
        break;
      default:
        break;
    }
  }
  return `${query}`;
}

function formatDate(date) {
  return moment(date).format("MMM DD YYYY", "h:mm:ss a");
}

function beforeUpload(file, size) {
  const isJpgOrPng =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "image/jpg" ||
    file.type === "image/webp";
  if (!isJpgOrPng) {
    toast.error("You can only upload JPG/PNG file!");
    return false;
  }

  const isLimit = file.size / 1024 / 1024 < size;
  if (!isLimit) {
    toast.error(`Image must smaller than ${size} MB!`);
    return false;
  }

  return true;
}

async function uploadImages({
  onSuccess,
  onError,
  file,
  onProgress,
  folder_name,
  access_token,
  csrf_token,
  image,
  setImage,
}) {
  const formData = new FormData();
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${access_token}`,
      Accept: `application/json`,
      "x-swagger-bypass": csrf_token,
      "Access-Control-Allow-Credentials": true,
    },
    withCredentials: true,
    onUploadProgress: (event) => {
      onProgress({ percent: (event.loaded / event.total) * 100 });
    },
  };

  formData.append("file", file);
  formData.append("folder_name", folder_name);
  if (image && image !== "") {
    formData.append("old_file_route", image);
  }

  await axios
    .post(`${UPLOAD_API}/${folder_name}`, formData, config)
    .then(({ data }) => {
      setImage(data);
      onSuccess("ok");
    })
    .catch((error) => onError({ error }));
}

async function uploadImagesForBanners({
  onSuccess,
  onError,
  file,
  onProgress,
  folder_name,
  access_token,
  csrf_token,
}) {
  const formData = new FormData();
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${access_token}`,
      Accept: `application/json`,
      "x-swagger-bypass": csrf_token,
      "Access-Control-Allow-Credentials": true,
    },
    withCredentials: true,
    onUploadProgress: onProgress
      ? (event) => {
          onProgress({ percent: (event.loaded / event.total) * 100 });
        }
      : undefined,
  };

  formData.append("file", file);
  formData.append("folder_name", folder_name);

  try {
    const response = await axios.post(
      `${UPLOAD_API}/${folder_name}`,
      formData,
      config
    );
    const uploadedUrl = response.data;
    if (onSuccess) onSuccess(uploadedUrl);
    return uploadedUrl;
  } catch (error) {
    if (onError) onError(error);
    throw error;
  }
}

function UploadButton(loading) {
  return (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
}


function toDecimalNum(data) {
  return new Decimal(data).toFixed(2)
}

function moneyFormat(amount) {
  const decimalAmount = toDecimalNum(amount);
  return parseFloat(decimalAmount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}


dayjs.extend(utc);
dayjs.extend(timezone);


export {
  requestHeader,
  queryHandler,
  beforeUpload,
  uploadImages,
  UploadButton,
  formatDate,
  uploadImagesForBanners,
  moneyFormat,
  dayjs
};

